import React from 'react'
import styled from 'styled-components'

import { CardNew } from 'features/project-form/components/CardNew'
import { FormTitle } from 'features/project-form/components/FormTitle'

type Props = {
  onBlankClick: () => void
  onCSVClick: () => void
  onEmptyClick?: () => void
}

export const Selector: React.FC<Props> = ({
  onBlankClick,
  onCSVClick,
  onEmptyClick,
}) => {
  return (
    <Wrapper $wide={!!onEmptyClick}>
      <FormTitle>Add Products and Sources</FormTitle>
      <Flex>
        <CardWrapper onClick={onBlankClick}>
          <CardNew text="Add products and sources to the project individually." />
        </CardWrapper>
        <CardWrapper onClick={onCSVClick}>
          <CardNew text="Upload a CSV to prefill new products and sources to add to the project." />
        </CardWrapper>
        {onEmptyClick && (
          <CardWrapper onClick={onEmptyClick}>
            <CardNew text="Create an empty project without products or sources." />
          </CardWrapper>
        )}
      </Flex>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $wide: boolean }>`
  width: ${({ $wide }) => ($wide ? 1000 : 700)}px;
`
const Flex = styled.div`
  display: flex;
  justify-content: space-around;
`
const CardWrapper = styled.div`
  width: 300px;
`
